'use client';

import React from 'react';

import { IconDepopIcon } from '@depop/web-ui-kit/Icons/IconDepopIcon';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import {
  ActivityTrackerEventType,
  NavCtaActionTypes,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';

export function SignupWallHeader() {
  const { sendActivityTrackerEvent } = useActivityTracker();

  function handleLogoClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: NavCtaActionTypes.DEPOP_LOGO_CTA,
    });
  }

  return (
    <header role="banner" id="globalHeader" className={styles.header}>
      <ExtendedLink
        href="/"
        onClick={handleLogoClick}
        aria-label="Depop homepage"
      >
        <IconDepopIcon className={styles.logo} aria-hidden="true" />
      </ExtendedLink>
    </header>
  );
}
